import React, { useContext } from "react"
import PropTypes from "prop-types"
import * as Yup from "yup"
import { Formik, Form, Field } from "formik"

import { SelectInput, TextInput, ReCAPTCHAInput, NumberInput } from "../forms"
import { Button, ErrorMessage } from "../styled"
import { QuestionsAndContactComponent } from "../index"
import { addOptionalReCaptchaSchema } from "../../utils/FormUtils"
import { AppContext } from "../context/AppContext"



const initialValues = {
  phoneNumber: "",
  promoCode: "",
  recaptcha: ""
}

export const NewSubmissionForm = ({ isLoading, onSubmit, isReCaptchaVisible }) => {
  const { state } = useContext(AppContext)
  const hasActiveAccounts = state.user.phoneNumbers.length > 0
  var isTFBAccount = state.user.isTFBAccount
  const isSprintAccount = state.user.Provider === "Sprint"
  const validPhoneLengthRegEx = /(^$)|(^\d{10}$)/

  let constantSchema = {
    phoneNumber: Yup.string().required( isSprintAccount
      ? "Sprint Phone Number is required"
      : "T-Mobile Phone Number is required"),
    promoCode: Yup.string().required("Promotion Code is required")
  }

  const validationSchema = addOptionalReCaptchaSchema(constantSchema, isReCaptchaVisible)
     
  const validatePhone = (value) => {
    let error
    if (!value && !isSprintAccount) {
      error = "T-Mobile phone number is required"
    }

    if (!value && isSprintAccount) {
      error = "Sprint phone number is required"
    }

    if (value && !value.replace(/[^a-z0-9]/g, "").match(validPhoneLengthRegEx)) {
      error = "T-Mobile phone number must be 10 digits"
    }

    if (value && (value.charAt(0) === "1" || value.charAt(0) === "0")) {
      error = "T-Mobile phone number cannot start with 0 or 1"
    }

    return error
  }

  const isSubmitButtonEnabled = (errors, isSubmitting, hasActiveAccounts, isTFBAccount) => {
    return Object.keys(errors).length > 0 || isSubmitting || (!hasActiveAccounts && !isTFBAccount)
  }

    return (
        <>
            {isLoading ? (<div>Loading ... </div>) :
              <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                {({ status, isSubmitting, errors }) => (
                  <Form>
                    <p className="">Fields marked with * are required</p>

                    {(!isTFBAccount && !isSprintAccount ) &&
                                <div className="row">
                                  <div className="form-group col-md-12">
                                    <label htmlFor="phonenumber">T-Mobile Phone Number*</label>
                                    <Field id="phonenumber" name="phoneNumber" component={SelectInput} disabled={!hasActiveAccounts} aria-required="true">
                                      <option value="">Select Sprint or T-Mobile Phone Number</option>
                                      {state.user && state.user.phoneNumbers.map((phoneNumber) => (<option value={phoneNumber} key={phoneNumber}>{phoneNumber}</option>))}
                                    </Field>
                                  </div>
                                </div>
                    }

                    {isTFBAccount &&
                                <div className="row">
                                  <div className="form-group col-md-12">
                                    <label htmlFor="tfbphonenumber">T-Mobile Phone Number*</label>
                                    <Field id="tfbphonenumber" name="phoneNumber" component={NumberInput} validate={validatePhone} type="tel" placeholder= "" arialabel="Enter T-Mobile phone number" maxLength={14} aria-required="true"></Field>
                                  </div>
                                </div>
                    }

                    { isSprintAccount &&
                                <div className="row">
                                  <div className="form-group col-md-12">
                                    <label htmlFor="sprintphonenumber">Sprint Phone Number*</label>
                                    <Field id="sprintphonenumber" name="phoneNumber" component={NumberInput} validate={validatePhone} type="tel" placeholder= "" arialabel="Enter Sprint phone number" maxLength={14} aria-required="true"></Field>
                                  </div>
                                </div>
                    }

                    <div className="row">
                      <div className="form-group col-md-12">
                        <label htmlFor="promocode">Promotion Code*</label>
                        <Field id="promocode" name="promoCode" component={TextInput} type="text" placeholder= "" arialabel="Enter the promotion code" disabled={(!hasActiveAccounts && !isTFBAccount)} aria-required="true"></Field>
                      </div>
                    </div>

                    {isReCaptchaVisible && (hasActiveAccounts || isTFBAccount) &&
                                <div className="row">
                                  <div className="col-md-12">
                                    <label htmlFor="recaptchacode">Recaptcha Code*</label>
                                    <Field id="recaptchacode" name="recaptcha" component={ReCAPTCHAInput} />
                                  </div>
                                </div>
                    }
                    {(!hasActiveAccounts && !isTFBAccount) &&
                                <div className="row">
                                  <div className="col-md-12">
                                    <ErrorMessage>You don&apos;t have an active T-Mobile account, or are not eligible for any promotions.</ErrorMessage>
                                  </div>
                                </div>
                    }
                    <div className="row">
                      <div className="col-md-12">
                        <QuestionsAndContactComponent />
                      </div>
                    </div>
                    <div className="mt-3 text-center text-md-left">
                      <Button aria-label="start button redirect to Next Page" aria-describedby="submit-errors" type="submit" className="btn" id="btnSubmit" primary aria-disabled={isSubmitButtonEnabled(errors, isSubmitting, hasActiveAccounts, isTFBAccount)} disabled={isSubmitButtonEnabled(errors, isSubmitting, hasActiveAccounts, isTFBAccount)}>{isSubmitting ? "Searching" : "Start"}</Button>
                      {status && status.formError && <div role="alert"><ErrorMessage id="submit-errors">{status.formError}</ErrorMessage></div>}
                    </div>
                  </Form>
                )}
              </Formik>}
        </>
  )
}

NewSubmissionForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isReCaptchaVisible: PropTypes.bool
}
